const ACTIONS = {
  createSnackbar: 'CREATE_SNACKBAR',
  destroySnackbar: 'DESTROY_SNACKBAR',
};

export default ACTIONS;
